import { render, staticRenderFns } from "./composer-attachments.vue?vue&type=template&id=0203be74&scoped=true&"
import script from "./composer-attachments.vue?vue&type=script&lang=js&"
export * from "./composer-attachments.vue?vue&type=script&lang=js&"
import style0 from "./composer-attachments.vue?vue&type=style&index=0&id=0203be74&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0203be74",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0203be74')) {
      api.createRecord('0203be74', component.options)
    } else {
      api.reload('0203be74', component.options)
    }
    module.hot.accept("./composer-attachments.vue?vue&type=template&id=0203be74&scoped=true&", function () {
      api.rerender('0203be74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/composer-attachments/composer-attachments.vue"
export default component.exports